import {FormField, type FormFieldData} from "@/types/permissions/form-fields";

export class Form {
    public id:number|null;
    public name:string;
    public json_resource_id:number|null;
    public formFields:FormField[];

    constructor(data:FormData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.name = "";
            this.json_resource_id = null;
            this.formFields=[];
        }
        else {
            this.id = data.id;
            this.name = data.name;
            this.json_resource_id = data.json_resource_id;

            this.formFields = [];
            if (data.formFields !== undefined) {
                data.formFields.forEach(formFields => this.formFields.push((new FormField(formFields))));
            }
        }
    }
    public resetToDefaults():void {
        this.id = null;
        this.name = '';
        this.json_resource_id = null;
        this.formFields=[];
    }
    public serializeData(): FormData {
        return {
            id: this.id,
            name: this.name,
            json_resource_id: this.json_resource_id,
            formFields:this.formFields
        }
    }
}

export type FormData = {
    id:number|null;
    name:string;
    json_resource_id:number|null;
    formFields: FormFieldData []| undefined;

}